'use client';

// Floating install button disabled for now; install is offered from Profile → Security when enabled.
// import PwaInstallCta from './PwaInstallCta';
import PwaPostInstallPushPrompt from './PwaPostInstallPushPrompt';
import PwaServiceWorkerManager from './PwaServiceWorkerManager';

export default function PwaBootstrap() {
  return (
    <>
      <PwaServiceWorkerManager />
      <PwaPostInstallPushPrompt />
      {/* <PwaInstallCta /> */}
    </>
  );
}
